import { RefObject } from 'react';

export const scrollTo = (ref: RefObject<HTMLElement>): void => {
  if (ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
};

export const scrollToObj = (ref: HTMLElement): void => {
  if (ref) {
    ref.scrollIntoView({ behavior: 'smooth' });
  }
};

export const scrollTop = () => {
  window.scrollTo(0, 0);
};

export function handleProductName(name: string) {
  const nameSplited = name.split(' - Digital')[0];
  if (nameSplited === 'Enfermeiro da Família' || nameSplited === 'Médico da Família') {
    const formatedName = nameSplited.split(' da');
    return `${formatedName[0]}(a) da${formatedName[1]}`;
  }
  return nameSplited;
}
